export default {"src":"/_next/static/media/trek_logo_new.5dc2e84e.svg","height":43,"width":213,"blurWidth":0,"blurHeight":0};